import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { StarbaseLoginService } from 'starbase-login';
import { AppGlobalsService } from './app-globals.service';
import { StarbaseModalOverlayService } from 'modal-overlay';

export interface IEditCheck {
  unsavedChangesCheck: () => Observable<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _overlaySvc: StarbaseModalOverlayService, private _router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this._loginSvc.isLoggedIn()) {
      const user = this._loginSvc.getUserModel();

      if (!user.isAdmin() && !user.hasPermissions('scaleread') && user.hasPermissions('voucherimportread')) {
        console.warn('User is vouchers only user. Re-routing...');
        this._router.navigate(['vouchers']);
        return false;
      }

      return true;
    }
    // otherwise we re-route to the login view
    console.warn('User not authenticated. Re-routing...');
    this._overlaySvc.disableOverlay();
    this._router.navigate(['login/out']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LookupsAuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this._loginSvc.getUserModel();

    return user.isAdmin() || user.hasPermissions('lookupread');
  }
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuardService implements CanDeactivate<IEditCheck> {
  public canDeactivate(component: IEditCheck): Observable<boolean> | boolean {
    const b = component.unsavedChangesCheck();
    if (typeof (b) === 'boolean') {
      return b;
    } else {
      return b.pipe(map(a => a));
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuardService implements CanActivate {
  constructor(private _loginSvc: StarbaseLoginService) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this._loginSvc.getUserModel().isAdmin();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReportsAuthGuardService implements CanActivate {
  constructor(private _loginSvc: StarbaseLoginService, private appGlobals: AppGlobalsService) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const user = this._loginSvc.getUserModel();

    return user.isAdmin() || user.hasPermissions('reportread') && this.appGlobals.site?.reportsActive;
  }
}

@Injectable({
  providedIn: 'root'
})
export class VoucherAuthGuardService implements CanActivate {

  constructor(private _loginSvc: StarbaseLoginService, private _router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this._loginSvc.getUserModel();

    return user.isAdmin() || user.hasPermissions('voucherimportread');
  }
}
